import { ChatFooterInstance } from "@/components/mobile/chat/common/ChatTextFooter.vue";
import { InputTypeEnum } from "@/enums/chatEnums";
import { useChat } from "@/stores/chat";
import { useChatSession } from "@/stores/chatSession";
import { useGlobalModal } from "@/stores/globalModal";
import { useMate } from "@/stores/mate";
import { ComputedRef, Ref, computed, ref, toRef, watch } from "vue";

export const useAutoRoundBoost = (
  sessionId: number,
  isStreamingReply: Ref<boolean>,
  postMessage?: ComputedRef<ChatFooterInstance["postMessage"] | undefined>,
  enable?: Ref<boolean> | ComputedRef<boolean>
) => {
  const enableRef = toRef(enable ?? true);
  const chat = useChat();
  const sessionStore = useChatSession();
  const mateStore = useMate();
  const targetMate = computed(
    () => mateStore.mateIdMap.get(currentSession.value!.mateId!)!
  );
  const messageList = computed(() => chat.messageListBySessionId(sessionId));
  const currentSession = computed(() => sessionStore.sessionMap[sessionId]);
  const characterList = computed(() => {
    const matePosition = currentSession.value.chatScene?.characterzz?.find(
      (c) => c.role === 2
    )?.currentPositionId;

    let t = currentSession.value.chatScene?.characterzz
      ?.filter((p) => p.currentPositionId === matePosition && p.role !== 2)
      .map((character) => ({
        label: character.mate!.name,
        value: character.mate!.name,
      })) ?? [{ label: targetMate.value.name, value: targetMate.value.name }];
    return t;
  });

  watch(isStreamingReply, async (curr, prev) => {
    if (
      !enableRef.value ||
      !currentSession.value ||
      curr ||
      !prev ||
      characterList.value.length === 0 ||
      !postMessage?.value ||
      useGlobalModal().showServerUpgradingModal
    )
      return;
    // 1. 获取最新的用户消息，创建滑动窗口
    const lastUserMsgIdx = messageList.value.findIndex(
      (msg) => msg.mateId === mateStore.currentMate?.id
    );
    if (lastUserMsgIdx === -1) return;
    const repliedMsgList = messageList.value
      .slice(0, lastUserMsgIdx)
      .filter((item) => item.fromNames.split(",").filter(Boolean).length <= 1);
    const repliedNameSet = repliedMsgList.reduce((acc, msg) => {
      msg.fromNames.split(",").forEach((name) => acc.add(name));
      return acc;
    }, new Set<string>());
    const restCharacters = characterList.value.filter(
      (character) => !repliedNameSet.has(character.value)
    );
    if (restCharacters.length === 0) return;
    await postMessage.value?.({
      inputType: InputTypeEnum.CONTINUE,
      text: "",
      toNames: [restCharacters[0].value],
      force: true,
      loadingPosition: "start",
    });
  });
};
